export const stateConstantas = {
  ADDDOM: "addDOM",
  DELETEDOM: "deleteDOM",
  CHOOSEDOM: "chooseDOM",
  INSERT: "insert",
  APPENDAFTER: "appendAfter",
  UPDOM: "upDOM",
  DOWNDOM: "downDOM",
  UPDATEMOUSEMOVE: "updatemousemove",
  UPDATETARGETDOM: "updateTargetDOM",
  UNDO: "undo",
  INDEX: "index",
};
